// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IBalanceTierDto
 */
export interface IBalanceTierDto {
    /**
     * 
     * @type {number}
     * @memberof IBalanceTierDto
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof IBalanceTierDto
     */
    version_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IBalanceTierDto
     */
    balance_from?: number;
    /**
     * 
     * @type {number}
     * @memberof IBalanceTierDto
     */
    balance_to?: number;
    /**
     * 
     * @type {number}
     * @memberof IBalanceTierDto
     */
    interest_rate_pct?: number;
    /**
     * 
     * @type {number}
     * @memberof IBalanceTierDto
     */
    apy_high_pct?: number;
    /**
     * 
     * @type {number}
     * @memberof IBalanceTierDto
     */
    apy_low_pct?: number;
}

/**
 * Check if a given object implements the IBalanceTierDto interface.
 */
export function instanceOfIBalanceTierDto(value: object): value is IBalanceTierDto {
    return true;
}

export function IBalanceTierDtoFromJSON(json: any): IBalanceTierDto {
    return IBalanceTierDtoFromJSONTyped(json, false);
}

export function IBalanceTierDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IBalanceTierDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'version_id': json['version_id'] == null ? undefined : json['version_id'],
        'balance_from': json['balance_from'] == null ? undefined : json['balance_from'],
        'balance_to': json['balance_to'] == null ? undefined : json['balance_to'],
        'interest_rate_pct': json['interest_rate_pct'] == null ? undefined : json['interest_rate_pct'],
        'apy_high_pct': json['apy_high_pct'] == null ? undefined : json['apy_high_pct'],
        'apy_low_pct': json['apy_low_pct'] == null ? undefined : json['apy_low_pct'],
    };
}

export function IBalanceTierDtoToJSON(json: any): IBalanceTierDto {
    return IBalanceTierDtoToJSONTyped(json, false);
}

export function IBalanceTierDtoToJSONTyped(value?: IBalanceTierDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'version_id': value['version_id'],
        'balance_from': value['balance_from'],
        'balance_to': value['balance_to'],
        'interest_rate_pct': value['interest_rate_pct'],
        'apy_high_pct': value['apy_high_pct'],
        'apy_low_pct': value['apy_low_pct'],
    };
}

